import { Box, Typography } from '@mui/material';
import DosenDarkLogo from "../../../assets/images/brand/dosen/dark-logo.png";

const ComingSoon = () => {
    return (
        <Box
            gap={3}
            display="flex"
            margin={'auto'}
            textAlign="center"
            minHeight="100vh"
            alignItems="center"
            flexDirection="column"
            justifyContent="center"
            maxWidth={{ xs: '85%', sm: '50%', lg: '40%' }}
        >
            <Box
                height="47px"
                width="234px"
                component={'img'}
                alt={"Dosen Logo"}
                src={DosenDarkLogo}
                sx={{color: 'black !important'}}
            />

            <Typography variant="h3" fontWeight={400} color="black">
Please activate your account on laptop or desktop.            </Typography>

            {/* <Typography
                variant="h3"
                component='a'
                color="black"
                fontWeight={400}
                target={"_blank"}
                href="https://dosen.io/"
                rel="noopener noreferrer"
            >
                dosen.io
            </Typography> */}
        </Box>
    );
};

export default ComingSoon;
